<template>
  <main class="adm-page">

    <div class="adm-header">
      <div>
        <h1 class="adm-header__title">Témoignages</h1>
        <p class="adm-header__sub">Modération des avis laissés par les utilisateurs</p>
      </div>
    </div>

    <!-- KPIs -->
    <div class="adm-kpis">
      <div class="adm-kpi adm-kpi--amber"><div class="adm-kpi__icon"><Clock /></div><span class="adm-kpi__val">{{ stats.pending||0 }}</span><span class="adm-kpi__lbl">En attente</span></div>
      <div class="adm-kpi adm-kpi--sage"><div class="adm-kpi__icon"><CheckCircle /></div><span class="adm-kpi__val">{{ stats.approved||0 }}</span><span class="adm-kpi__lbl">Publiés</span></div>
      <div class="adm-kpi adm-kpi--forest"><div class="adm-kpi__icon"><Star /></div><span class="adm-kpi__val">{{ stats.featured||0 }}</span><span class="adm-kpi__lbl">Mis en avant</span></div>
      <div class="adm-kpi"><div class="adm-kpi__icon"><Star /></div><span class="adm-kpi__val">{{ stats.average_rating||'—' }}/5</span><span class="adm-kpi__lbl">Note moyenne</span></div>
    </div>

    <!-- Filtres -->
    <div class="adm-filters">
      <div class="adm-search" style="flex:1;min-width:200px"><Search /><input v-model="filters.search" @input="debounceSearch" placeholder="Nom, contenu, rôle…" class="adm-input" /></div>
      <select v-model="filters.status" @change="loadReviews" class="adm-input adm-input--sm">
        <option value="">Tous statuts</option><option value="pending">En attente</option>
        <option value="approved">Approuvés</option><option value="rejected">Rejetés</option>
      </select>
      <select v-model="filters.source_type" @change="loadReviews" class="adm-input adm-input--sm">
        <option value="">Toutes sources</option><option value="beneficiaire">Bénéficiaire</option>
        <option value="partenaire">Partenaire</option><option value="formateur">Formateur</option>
        <option value="donateur">Donateur</option><option value="autre">Autre</option>
      </select>
      <button class="adm-btn adm-btn--outline adm-btn--sm" @click="resetFilters"><X />Réinitialiser</button>
    </div>

    <!-- Table -->
    <div class="adm-card">
      <div v-if="loading" class="adm-loading"><span class="adm-ring"></span></div>
      <div v-else>
        <div class="adm-table-wrap">
          <table class="adm-table">
            <thead>
              <tr><th>Auteur</th>
                <!-- <th>Témoignage</th> -->
                <th>Note</th><th>Source</th><th>Statut</th><th>En avant</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              <tr v-if="!reviews.length"><td colspan="8" class="adm-table__empty">Aucun avis trouvé</td></tr>
              <tr v-for="r in reviews" :key="r.id" :style="r.status==='pending'?'border-left:3px solid var(--amber)':''">
                <td data-label="Auteur">
                  <div style="display:flex;align-items:center;gap:.65rem">
                    <div class="adm-avatar" style="width:34px;height:34px;font-size:.75rem">{{ initials(r.name) }}</div>
                    <div><div class="adm-cell-title" style="max-width:none">{{ r.name }}</div><div class="adm-cell-sub">{{ r.role||r.organisation||'—' }}</div></div>
                  </div>
                </td>
                <!-- <td data-label="Témoignage"><p style="font-size:.83rem;color:var(--ink-60);line-height:1.5;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;">{{ r.content }}</p></td> -->
                <td data-label="Note"><span class="rv-stars">{{ '★'.repeat(r.rating) }}<span style="color:var(--ink-12)">{{ '★'.repeat(5-r.rating) }}</span></span></td>
                <td data-label="Source"><span class="adm-chip">{{ sourceLabel(r.source_type) }}</span></td>
                <td data-label="Statut">
                  <span class="adm-badge" :class="{'adm-badge--amber':r.status==='pending','adm-badge--green':r.status==='approved','adm-badge--red':r.status==='rejected'}">{{ statusLabel(r.status) }}</span>
                </td>
                <td data-label="En avant">
                  <div class="adm-toggle" :class="{'adm-toggle--on':r.is_featured}" @click="toggleFeatured(r)"><span class="adm-toggle__knob"></span></div>
                </td>
                <td data-label="Date" class="adm-cell-date">{{ fmtDate(r.created_at) }}</td>
                <td class="no-label">
                  <div class="adm-actions">
                    <button v-if="r.status!=='approved'" class="adm-btn adm-btn--xs adm-btn--green" @click="approve(r)" title="Approuver"><CheckCircle /></button>
                    <button class="adm-btn adm-btn--xs adm-btn--outline" @click="openDetail(r)" title="Modifier"><Edit /></button>
                    <button v-if="r.status!=='rejected'" class="adm-btn adm-btn--xs adm-btn--red" @click="openReject(r)" title="Rejeter"><XCircle /></button>
                    <button class="adm-btn adm-btn--xs adm-btn--red" @click="confirmDelete(r)" title="Supprimer"><Trash2 /></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="pagination.last_page>1" class="adm-pagination">
          <p class="adm-pagination__info">{{ pagination.total }} avis</p>
          <div class="adm-pagination__pages">
            <button class="adm-page-btn" :disabled="pagination.current_page===1" @click="changePage(pagination.current_page-1)"><ChevronLeft /></button>
            <button v-for="p in displayedPages" :key="p" class="adm-page-btn" :class="{'adm-page-btn--active':pagination.current_page===p}" @click="changePage(p)">{{ p }}</button>
            <button class="adm-page-btn" :disabled="pagination.current_page===pagination.last_page" @click="changePage(pagination.current_page+1)"><ChevronRight /></button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Détail / Édition -->
    <Transition name="adm-modal">
      <div v-if="showDetail && selected" class="adm-modal" @click.self="showDetail=false">
        <div class="adm-modal__box adm-modal__box--lg">
          <div class="adm-modal__head"><h3 class="adm-modal__title">Avis de {{ selected.name }}</h3><button class="adm-modal__close" @click="showDetail=false"><X /></button></div>
          <div class="adm-modal__body">
            <div class="adm-detail-grid">
              <div class="adm-detail-row"><p class="adm-detail-row__label">Email</p><p class="adm-detail-row__val">{{ selected.email||'—' }}</p></div>
              <div class="adm-detail-row"><p class="adm-detail-row__label">Note</p><p class="adm-detail-row__val"><span class="rv-stars">{{ '★'.repeat(selected.rating) }}</span> {{ selected.rating }}/5</p></div>
            </div>
            <div class="adm-form-grid">
              <div class="adm-field"><label class="adm-label">Nom affiché</label><input v-model="editForm.name" class="adm-input" /></div>
              <div class="adm-field"><label class="adm-label">Rôle affiché</label><input v-model="editForm.role" class="adm-input" /></div>
            </div>
            <div class="adm-field"><label class="adm-label">Témoignage</label><textarea v-model="editForm.content" rows="4" class="adm-input adm-textarea"></textarea></div>
            <div class="adm-field"><label class="adm-label">Note admin (interne)</label><textarea v-model="editForm.admin_note" rows="2" class="adm-input adm-textarea" placeholder="Visible uniquement par l'équipe admin…"></textarea></div>
          </div>
          <div class="adm-modal__foot">
            <button class="adm-btn adm-btn--outline" @click="showDetail=false">Fermer</button>
            <button class="adm-btn adm-btn--forest" @click="saveEdit"><CheckCircle />Enregistrer</button>
            <button v-if="selected.status!=='approved'" class="adm-btn adm-btn--green" @click="approve(selected);showDetail=false"><CheckCircle />Approuver</button>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Modal Rejet -->
    <Transition name="adm-modal">
      <div v-if="showReject" class="adm-modal" @click.self="showReject=false">
        <div class="adm-modal__box">
          <div class="adm-modal__head"><h3 class="adm-modal__title">Rejeter l'avis</h3><button class="adm-modal__close" @click="showReject=false"><X /></button></div>
          <div class="adm-modal__body">
            <div class="adm-warn adm-warn--amber"><AlertTriangle />L'avis ne sera plus visible par le public.</div>
            <div class="adm-field" style="margin-top:.75rem"><label class="adm-label">Raison du rejet (interne)</label><textarea v-model="rejectNote" rows="3" class="adm-input adm-textarea" placeholder="Contenu inapproprié, doublon…"></textarea></div>
          </div>
          <div class="adm-modal__foot">
            <button class="adm-btn adm-btn--outline" @click="showReject=false">Annuler</button>
            <button class="adm-btn adm-btn--red" @click="submitReject"><XCircle />Confirmer le rejet</button>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Delete confirm -->
    <Transition name="adm-modal">
      <div v-if="showDeleteConfirm" class="adm-modal" @click.self="showDeleteConfirm=false">
        <div class="adm-modal__box">
          <div class="adm-modal__head"><h3 class="adm-modal__title">Supprimer l'avis ?</h3><button class="adm-modal__close" @click="showDeleteConfirm=false"><X /></button></div>
          <div class="adm-modal__body"><div class="adm-confirm"><div class="adm-confirm__icon"><Trash2 /></div><h3>Confirmer</h3><p>L'avis de « {{ toDelete?.name }} » sera supprimé.</p></div></div>
          <div class="adm-modal__foot"><button class="adm-btn adm-btn--outline" @click="showDeleteConfirm=false">Annuler</button><button class="adm-btn adm-btn--red" @click="deleteConfirmed"><Trash2 />Supprimer</button></div>
        </div>
      </div>
    </Transition>

    <Transition name="adm-toast"><div v-if="toast.msg" class="adm-toast" :class="{'adm-toast--error':toast.type==='error'}"><CheckCircle />{{ toast.msg }}</div></Transition>
  </main>
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'
import { Search, X, XCircle, ChevronLeft, ChevronRight, Edit, Trash2, CheckCircle, Star, Clock, AlertTriangle } from 'lucide-vue-next'

const API = () => {
  const token = localStorage.getItem('token')
  return axios.create({ baseURL:'https://api.stagfondation.org/api/admin', headers:{ Authorization:`Bearer ${token}` } })
}

export default {
  name: 'AdminReviews',
  components: { Search, X, XCircle, ChevronLeft, ChevronRight, Edit, Trash2, CheckCircle, Star, Clock, AlertTriangle },
  data() {
    return {
      loading:false,
      reviews:[], stats:{}, pagination:{ current_page:1, last_page:1, total:0 }, displayedPages:[],
      filters:{ search:'', status:'', source_type:'', sort_by:'created_at', sort_order:'desc' },
      showDetail:false, selected:null, editForm:{ name:'', role:'', content:'', admin_note:'' },
      showReject:false, toReject:null, rejectNote:'',
      showDeleteConfirm:false, toDelete:null,
      toast:{ msg:'', type:'success' }
    }
  },
  created() { this.debounceSearch=debounce(this.loadReviews,450); this.loadReviews() },
  methods: {
    async loadReviews() {
      this.loading=true
      try { const { data }=await API().get('/reviews',{ params:{...this.filters,page:this.pagination.current_page} }); this.reviews=data.data; this.pagination=data.meta; this.stats=data.stats||{}; this.updatePages() }
      catch { this.showToast('Erreur de chargement','error') }
      finally { this.loading=false }
    },
    async approve(r) { try { await API().patch(`/reviews/${r.id}/approve`); this.showToast('Avis approuvé !'); this.loadReviews() } catch { this.showToast('Erreur','error') } },
    openReject(r) { this.toReject=r; this.rejectNote=''; this.showReject=true },
    async submitReject() { try { await API().patch(`/reviews/${this.toReject.id}/reject`,{ note:this.rejectNote }); this.showToast('Avis rejeté'); this.showReject=false; this.loadReviews() } catch { this.showToast('Erreur','error') } },
    async toggleFeatured(r) { try { const { data }=await API().patch(`/reviews/${r.id}/toggle-featured`); r.is_featured=data.is_featured; this.showToast(data.message) } catch { this.showToast('Erreur','error') } },
    openDetail(r) { this.selected=r; this.editForm={ name:r.name, role:r.role||'', content:r.content, admin_note:r.admin_note||'' }; this.showDetail=true },
    async saveEdit() { try { await API().patch(`/reviews/${this.selected.id}`,this.editForm); this.showToast('Avis mis à jour'); this.showDetail=false; this.loadReviews() } catch { this.showToast('Erreur','error') } },
    confirmDelete(r) { this.toDelete=r; this.showDeleteConfirm=true },
    async deleteConfirmed() { try { await API().delete(`/reviews/${this.toDelete.id}/delete`); this.showToast('Avis supprimé'); this.showDeleteConfirm=false; this.toDelete=null; this.loadReviews() } catch { this.showToast('Erreur','error') } },
    resetFilters() { this.filters={ search:'', status:'', source_type:'', sort_by:'created_at', sort_order:'desc' }; this.loadReviews() },
    changePage(p) { if(p>=1&&p<=this.pagination.last_page){ this.pagination.current_page=p; this.loadReviews() } },
    updatePages() { const c=this.pagination.current_page,l=this.pagination.last_page,d=2,pages=[]; for(let i=1;i<=l;i++) if(i===1||i===l||(i>=c-d&&i<=c+d)) pages.push(i); this.displayedPages=pages },
    initials(n) { return (n||'?').split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) },
    statusLabel(s) { return{ pending:'En attente',approved:'Approuvé',rejected:'Rejeté' }[s]||s },
    sourceLabel(s) { return{ beneficiaire:'Bénéficiaire',partenaire:'Partenaire',formateur:'Formateur',donateur:'Donateur',autre:'Autre' }[s]||'Autre' },
    fmtDate(d) { return d?new Date(d).toLocaleDateString('fr-FR',{day:'2-digit',month:'short',year:'numeric'}):'—' },
    showToast(msg,type='success') { this.toast={msg,type}; setTimeout(()=>{this.toast={msg:'',type:'success'}},4000) }
  }
}
</script>
<style>@import './admin.css';</style>
<style scoped>.rv-stars { color:var(--amber); font-size:.95rem; }</style>